/* ═══════════════════════════════════════════════════
   EMPIRE GOLF — THEME.JS v2.3
═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  let cartBusy = false;

  /* ─── CART ──────────────────────────────────────── */
  const Cart = {
    overlay:  document.getElementById('cartOverlay'),
    drawer:   document.getElementById('cartDrawer'),
    itemsEl:  document.getElementById('cartItems'),
    footerEl: document.getElementById('cartFooter'),
    countEl:  document.getElementById('cartItemCount'),
    bubbleEl: document.getElementById('cartBubble'),
    totalEl:  document.getElementById('cartTotal'),

    open() {
      this.overlay.classList.add('open');
      this.drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    },
    close() {
      this.overlay.classList.remove('open');
      this.drawer.classList.remove('open');
      document.body.style.overflow = '';
    },

    async fetch() {
      try {
        const res  = await fetch('/cart.js', { cache: 'no-store' });
        const data = await res.json();
        this.render(data);
        return data;
      } catch (e) {
        console.error('Cart fetch error:', e);
      }
    },

    async add(variantId, quantity) {
      quantity = quantity || 1;
      if (cartBusy) return;
      cartBusy = true;

      var btn = document.getElementById('addToCartBtn');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) })
        });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add item');
        await this.fetch();
        this.open();
        Toast.show(data.product_title + ' added to your bag');
      } catch (e) {
        Toast.show(e.message || 'Could not add item to bag');
      } finally {
        cartBusy = false;
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
      }
    },

    async remove(key) {
      if (cartBusy) return;
      cartBusy = true;

      var itemEl = document.querySelector('.cart-item[data-key="' + key + '"]');
      if (itemEl) {
        itemEl.style.opacity = '0.4';
        itemEl.style.pointerEvents = 'none';
      }

      try {
        var res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        if (!res.ok) throw new Error('Failed to remove item');
        await this.fetch();
      } catch (e) {
        if (itemEl) {
          itemEl.style.opacity = '1';
          itemEl.style.pointerEvents = 'all';
        }
        Toast.show('Could not remove item. Please try again.');
      } finally {
        cartBusy = false;
      }
    },

    async changeQty(key, qty) {
      qty = parseInt(qty);
      if (isNaN(qty) || qty < 0) return;
      if (qty === 0) { return this.remove(key); }
      if (cartBusy) return;
      cartBusy = true;

      var itemEl = document.querySelector('.cart-item[data-key="' + key + '"]');
      if (itemEl) { itemEl.style.opacity = '0.45'; itemEl.style.pointerEvents = 'none'; }

      try {
        var res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        if (!res.ok) throw new Error('Failed to update quantity');
        await this.fetch();
      } catch (e) {
        if (itemEl) { itemEl.style.opacity = '1'; itemEl.style.pointerEvents = 'all'; }
        Toast.show('Could not update quantity. Please try again.');
      } finally {
        cartBusy = false;
      }
    },

    render(cart) {
      var count = cart.item_count;
      if (this.countEl)  this.countEl.textContent  = count;
      if (this.bubbleEl) this.bubbleEl.textContent = count;
      if (this.totalEl)  this.totalEl.textContent  = this._money(cart.total_price);
      if (this.footerEl) this.footerEl.style.display = count > 0 ? 'block' : 'none';

      var cartLabel = document.querySelector('.mobile-cart-label');
      if (cartLabel) cartLabel.textContent = 'Cart (' + count + ')';

      if (count === 0) {
        this.itemsEl.innerHTML = '<div class="cart-empty"><p class="cart-empty-label">Your bag is empty.</p><a href="/collections/all" class="btn btn-dark" id="cartShopLink">Shop Now</a></div>';
        var shopLink = document.getElementById('cartShopLink');
        if (shopLink) shopLink.addEventListener('click', function() { Cart.close(); });
        return;
      }

      var html = '';
      for (var i = 0; i < cart.items.length; i++) {
        var item     = cart.items[i];
        var variant  = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        var qtyMinus = item.quantity - 1;
        var qtyPlus  = item.quantity + 1;
        html += '<div class="cart-item" data-key="' + item.key + '" style="transition:opacity 0.3s;">';
        html += '<div class="cart-item-img"><a href="' + item.url + '"><img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy" width="80" height="107"></a></div>';
        html += '<div class="cart-item-details">';
        html += '<p class="cart-item-name">' + item.product_title + '</p>';
        if (variant) html += '<p class="cart-item-meta">' + variant + '</p>';
        html += '<p class="cart-item-price">' + this._money(item.final_price) + '</p>';
        html += '<div class="cart-item-qty">';
        html += '<button type="button" class="cart-qty-btn" data-key="' + item.key + '" data-qty="' + qtyMinus + '" aria-label="Decrease quantity">&#8722;</button>';
        html += '<span class="cart-qty-num">' + item.quantity + '</span>';
        html += '<button type="button" class="cart-qty-btn" data-key="' + item.key + '" data-qty="' + qtyPlus + '" aria-label="Increase quantity">+</button>';
        html += '</div>';
        html += '</div>';
        html += '<button type="button" class="cart-remove" data-key="' + item.key + '" aria-label="Remove item">&#215;</button>';
        html += '</div>';
      }
      this.itemsEl.innerHTML = html;
    },

    _money(cents) {
      var amount = (cents / 100).toFixed(2);
      return '$' + amount.replace(/\.00$/, '');
    }
  };

  /* ─── SEARCH ────────────────────────────────────── */
  var Search = {
    modal: document.getElementById('searchModal'),
    input: document.getElementById('searchInput'),
    open: function() {
      this.modal.classList.add('open');
      document.body.style.overflow = 'hidden';
      var self = this;
      setTimeout(function() { if (self.input) self.input.focus(); }, 100);
    },
    close: function() {
      this.modal.classList.remove('open');
      document.body.style.overflow = '';
    }
  };

  /* ─── TOAST ─────────────────────────────────────── */
  var Toast = {
    el: document.getElementById('toast'),
    timer: null,
    show: function(msg, duration) {
      duration = duration || 3500;
      if (!this.el) return;
      this.el.textContent = msg;
      this.el.classList.add('show');
      clearTimeout(this.timer);
      var el = this.el;
      this.timer = setTimeout(function() { el.classList.remove('show'); }, duration);
    }
  };

  /* ─── MOBILE MENU ───────────────────────────────── */
  var MobileMenu = {
    toggle: document.getElementById('mobileMenuToggle'),
    menu:   document.getElementById('mobileMenu'),
    isOpen: false,
    open: function() {
      this.isOpen = true;
      if (this.menu)   this.menu.classList.add('open');
      if (this.toggle) this.toggle.classList.add('open');
      document.body.style.overflow = 'hidden';
    },
    close: function() {
      this.isOpen = false;
      if (this.menu)   this.menu.classList.remove('open');
      if (this.toggle) this.toggle.classList.remove('open');
      document.body.style.overflow = '';
    },
    toggle_: function() {
      if (this.isOpen) { this.close(); } else { this.open(); }
    }
  };

  /* ─── QUICK ADD ─────────────────────────────────── */
  function handleQuickAdd(btn) {
    if (cartBusy) return;
    var productUrl = btn.dataset.productUrl;
    if (!productUrl) return;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';
    fetch(productUrl, { cache: 'no-store' })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var variant = null;
        for (var i = 0; i < data.variants.length; i++) {
          if (data.variants[i].available) { variant = data.variants[i]; break; }
        }
        if (!variant) variant = data.variants[0];
        if (!variant) { Toast.show('Product unavailable'); return; }
        Cart.add(variant.id);
      })
      .catch(function() { Toast.show('Could not add product'); })
      .finally(function() { btn.textContent = originalText; });
  }

  /* ─── PRODUCT FORM ──────────────────────────────── */
  function handleProductFormSubmit(e) {
    e.preventDefault();
    var form      = e.target;
    var variantEl = form.querySelector('[name="id"]');
    var qtyEl     = form.querySelector('[name="quantity"]');
    var variantId = variantEl ? variantEl.value : null;
    var quantity  = qtyEl ? parseInt(qtyEl.value) : 1;
    if (!variantId) { Toast.show('Please select options'); return; }
    Cart.add(variantId, quantity);
  }

  /* ─── ACCORDION ─────────────────────────────────── */
  window.toggleAccordion = function(btn) {
    var content = btn.nextElementSibling;
    var isOpen  = content.style.maxHeight;
    document.querySelectorAll('.accordion-content').forEach(function(c) { c.style.maxHeight = ''; });
    document.querySelectorAll('.accordion-trigger span').forEach(function(s) { s.textContent = '+'; });
    if (!isOpen) {
      content.style.maxHeight = content.scrollHeight + 'px';
      btn.querySelector('span').textContent = '−';
    }
  };

  /* ─── QTY ───────────────────────────────────────── */
  window.adjustQty = function(delta) {
    var input = document.getElementById('qtyInput');
    if (input) input.value = Math.max(1, parseInt(input.value) + delta);
  };

  /* ─── SCROLL REVEAL ─────────────────────────────── */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.product-card, .col-card, .testimonial, .feature-item, .reveal').forEach(function(el, i) {
      el.classList.add('reveal');
      el.style.transitionDelay = Math.min(i * 0.06, 0.4) + 's';
      revealObserver.observe(el);
    });
  }

  /* ─── HEADER SCROLL ─────────────────────────────── */
  var header = document.querySelector('.site-header');
  window.addEventListener('scroll', function() {
    if (window.scrollY > 50) {
      if (header) header.classList.add('header-scrolled');
    } else {
      if (header) header.classList.remove('header-scrolled');
    }
  }, { passive: true });

  /* ─── COLLECTION SORT/FILTER ────────────────────── */
  window.sortCollection = function(val) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', val);
    window.location.href = url.toString();
  };

  window.applyFilter = function(el) {
    var url     = new URL(window.location.href);
    var checked = document.querySelectorAll('input[name="' + el.name + '"]:checked');
    url.searchParams.delete(el.name);
    checked.forEach(function(c) { url.searchParams.append(el.name, c.value); });
    window.location.href = url.toString();
  };

  window.toggleFilter = function(btn) {
    var opts   = btn.nextElementSibling;
    var isOpen = opts.style.display === 'block';
    opts.style.display = isOpen ? 'none' : 'block';
    btn.querySelector('span').textContent = isOpen ? '+' : '−';
  };

  /* ─── EVENT LISTENERS ───────────────────────────── */
  var cartToggle    = document.getElementById('cartToggle');
  var cartClose     = document.getElementById('cartClose');
  var cartOverlay   = document.getElementById('cartOverlay');
  var mobileCartBtn = document.getElementById('mobileCartBtn');
  var searchToggle  = document.getElementById('searchToggle');
  var searchClose   = document.getElementById('searchClose');
  var mobileSearch  = document.getElementById('mobileSearchBtn');
  var mobileToggle  = document.getElementById('mobileMenuToggle');
  var productForm   = document.getElementById('product-form');
  var cartItems     = document.getElementById('cartItems');

  if (cartToggle)    cartToggle.addEventListener('click',   function() { Cart.open(); });
  if (cartClose)     cartClose.addEventListener('click',    function() { Cart.close(); });
  if (cartOverlay)   cartOverlay.addEventListener('click',  function() { Cart.close(); });
  if (mobileCartBtn) mobileCartBtn.addEventListener('click', function() { Cart.open(); });
  if (searchToggle)  searchToggle.addEventListener('click', function() { Search.open(); });
  if (searchClose)   searchClose.addEventListener('click',  function() { Search.close(); });
  if (mobileSearch)  mobileSearch.addEventListener('click', function() { Search.open(); });
  if (mobileToggle)  mobileToggle.addEventListener('click', function() { MobileMenu.toggle_(); });
  if (productForm)   productForm.addEventListener('submit', handleProductFormSubmit);

  if (cartItems) {
    cartItems.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('.cart-remove');
      if (removeBtn && !cartBusy) {
        e.preventDefault();
        e.stopPropagation();
        var key = removeBtn.dataset.key;
        if (key) Cart.remove(key);
        return;
      }
      var qtyBtn = e.target.closest('.cart-qty-btn');
      if (qtyBtn && !cartBusy) {
        e.preventDefault();
        e.stopPropagation();
        var key = qtyBtn.dataset.key;
        var qty = qtyBtn.dataset.qty;
        if (key !== undefined && qty !== undefined) Cart.changeQty(key, qty);
      }
    });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.product-quick');
    if (btn && btn.dataset.productUrl) {
      e.preventDefault();
      handleQuickAdd(btn);
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      Cart.close();
      Search.close();
      MobileMenu.close();
    }
  });

  document.querySelectorAll('.filter-options').forEach(function(el) { el.style.display = 'block'; });
  document.querySelectorAll('.filter-group-title span').forEach(function(s) { s.textContent = '−'; });

  var prefetchedUrls = new Set();
  document.addEventListener('mouseover', function(e) {
    var link = e.target.closest('a');
    if (!link || !link.href) return;
    if (link.hostname !== window.location.hostname) return;
    if (link.href.includes('#')) return;
    if (prefetchedUrls.has(link.href)) return;
    prefetchedUrls.add(link.href);
    var prefetch = document.createElement('link');
    prefetch.rel = 'prefetch';
    prefetch.href = link.href;
    document.head.appendChild(prefetch);
  }, { passive: true });

  window.EmpireCart  = Cart;
  window.EmpireToast = Toast;

})();